import React from 'react';

export default function FormSwitch(props) {
  const { register, errors, name, label, required, onChange, checked } = props;

  return (
    <>
      <div className="form-check form-switch  ">
        <input
          className="form-check-input appearance-none w-9 ml-2 text-gray-900 text-sm rounded-full h-5 align-top  bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm"
          type="checkbox"
          role="switch"
          {...register(`${name}`)}
          checked={checked}
          onChange={onChange}
          name={name}
        />
      </div>
      <span className="text-gray-900 text-sm">{label}</span>
    </>
  );
}

FormSwitch.defaultProps = {
  checked: false,
};
